import { Badge, Popover, Tag } from "antd";

export const ListColumn = ({ listRow, label, t }: any) =>
  listRow?.length > 3 ? (
    <Popover
      overlayClassName="popover-country-genre"
      content={
        <div style={{ width: 500, textAlign: "center" }}>
          <span style={{ display: "block" }}>{label}</span>
          {listRow.slice(1).map((item: any) => (
            <Tag style={{ marginBottom: 8 }} key={Math.random()}>
              {item}
            </Tag>
          ))}
        </div>
      }
    >
      <Badge count={listRow.slice(1).length} status="default" color="#333333">
        <Tag key={Math.random()}>{t("pages.LabelsRanking.many")}</Tag>
      </Badge>
    </Popover>
  ) : (
    listRow.map(
      (item: any) =>
        item && (
          <Tag style={{ marginBottom: 8 }} key={Math.random()}>
            {item}
          </Tag>
        )
    ) || ""
  );
